import { markupApi } from "@/api";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  current_field: {},
  error: null,
};

export const getFieldMeta = createAsyncThunk(
  "field/getFieldMeta",
  async (videoId, { dispatch }) => {
    try {
      const data = await markupApi.getFieldMeta(videoId);
      dispatch(setField(data));
    } catch (e) {
      dispatch(setFieldError(e.response));
    }
  }
);

export const updateFieldMeta = createAsyncThunk(
  "field/getFieldMeta",
  async (videoId, data, { dispatch }) => {
    try {
      return await markupApi.updateFieldMeta(videoId, data);
    } catch (e) {
      dispatch(setFieldError(e.response));
      return e.response;
    }
  }
);

const fieldSlice = createSlice({
  name: "field",
  initialState,
  reducers: {
    setField(state, action) {
      state.current_field = action.payload;
      state.error = false;
    },
    setFieldError(state, action) {
      state.error = action.payload;
    },
  },
});

export const { setField, setFieldError } = fieldSlice.actions;

export default fieldSlice.reducer;
